<template>
  <div class="database-switcher-enhanced">
    <!-- Dropdown -->
    <div class="dropdown">
      <button class="dropdown-toggle nav-link enhanced-nav-link" type="button" data-bs-toggle="dropdown" :disabled="loading">
        <i class="switch-icon fas fa-database me-1"></i>
        {{ getCurrentDBDescription() }}
        <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
      </button>
      
      <ul class="dropdown-menu dropdown-menu-end enhanced-dropdown-menu">
        <li><h6 class="dropdown-header">Select Site Database</h6></li>
        <li v-for="db in databases" :key="db.name">
          <a class="dropdown-item enhanced-dropdown-item db-option" href="#" @click="switchDatabase(db.name)">
            <div class="db-option-content">
              <span class="db-label">{{ db.label }}</span>
              <small class="db-desc text-muted">{{ getDBDescription(db.name) }}</small>
            </div>
           <i v-if="getDBName(currentDatabase) === getDBName(db.name)" class="active-indicator fas fa-check text-success"></i>
          </a>
        </li>
        
        <!-- User Database Assignment Section - للادمنز فقط -->
        <li v-if="isAdminUser">
          <hr class="dropdown-divider">
          <h6 class="dropdown-header">User Management</h6>
          
          <!-- Current User Info -->
          <div class="dropdown-item-text px-3 py-2">
            <small class="text-muted d-block">Current User:</small>
            <strong>{{ currentUser?.username }}</strong>
            <span class="badge bg-warning ms-1">{{ getUserRole() }}</span>
          </div>
          
          <!-- Assign to Current User -->
          <a class="dropdown-item enhanced-dropdown-item text-primary" href="#" @click="assignToCurrentUser">
            <i class="fas fa-user-check me-2"></i>
            Assign Current Site to Me
          </a>
          
          <!-- Admin Panel Link -->
          <a class="dropdown-item enhanced-dropdown-item text-info" href="#" @click="openUserManager">
            <i class="fas fa-users-cog me-2"></i>
            Manage All Users
          </a>
        </li>
        
        <li><hr class="dropdown-divider"></li>
        <li>
          <a class="dropdown-item enhanced-dropdown-item text-info" href="#" @click="refreshDatabases">
            <i class="refresh-icon fas fa-sync-alt me-2"></i>
            Refresh List
          </a>
        </li>
      </ul>
    </div>

    <!-- Messages -->
    <div v-if="message" class="alert-message" :class="messageType">
      <i class="message-icon" :class="getMessageIconClass(messageType)"></i>
      {{ message }}
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'DatabaseSwitcher',
  data() {
    return {
      databases: [],
      currentDatabase: '',
      currentUser: null,
      loading: false,
      message: '',
      messageType: '' // success, error, info
    };
  },
  computed: {
    isAdminUser() {
      return this.currentUser?.roles?.includes('super_admin') || 
             this.currentUser?.roles?.includes('admin');
    }
  },
  async mounted() {
    await this.loadCurrentUser();
    await this.loadDatabases();
  },
  methods: {
    async loadCurrentUser() {
      try {
        const userData = localStorage.getItem('user');
        if (userData) {
          this.currentUser = JSON.parse(userData);
        }
      } catch (error) {
        console.error('Failed to load current user:', error);
      }
    },

    async loadDatabases() {
  try {
    this.loading = true;
    const response = await api.get('/db/databases');
    this.databases = response.data.databases;
    this.currentDatabase = response.data.currentDB?.name || ''; // تغيير هنا من database إلى name
    this.showMessage('Databases loaded successfully', 'success');
  } catch (error) {
    console.error('❌ Failed to load databases:', error);
    this.showMessage('Failed to load databases', 'error');
  } finally {
    this.loading = false;
  }
},

    async switchDatabase(dbName) {
      if (!dbName) return;

      event.preventDefault(); // نضيف دي


      this.loading = true;
      this.message = '';
      
      try {
        const token = localStorage.getItem('token');
        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        };
        
        const response = await api.post('/db/switch', {
          dbName: dbName
        }, config);
        
        this.currentDatabase = response.data.currentDatabase;
        this.showMessage(response.data.message, 'success');
        
        this.$emit('database-changed', dbName);
        
        // نعمل refresh للصفحة بعد 3 ثواني
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        
      } catch (error) {
        console.error('❌ Switch failed:', error);
        this.showMessage(error.response?.data?.message || 'Failed to switch database', 'error');
      } finally {
        this.loading = false;
      }
    },

    async assignToCurrentUser() {
      if (!this.currentUser || !this.currentDatabase) return;
      
      this.loading = true;
      
      try {
        const token = localStorage.getItem('token');
        const config = {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        };
        
        // نحدد أي داتابيز نحطها للـ user
        const targetDB = this.getDatabaseKeyFromName(this.currentDatabase);
        
        if (!targetDB) {
          this.showMessage('Cannot determine target database', 'error');
          return;
        }
        
        const response = await api.post('/db/update-user-db', {
          userId: this.currentUser.id,
          database: targetDB
        }, config);
        
        this.showMessage(`Assigned ${this.currentUser.username} to ${this.currentDatabase}`, 'success');
        
        // نعمل logout ثم login تاني علشان التغييرات تاخد effect
        setTimeout(() => {
          this.showMessage('Please logout and login again for changes to take effect', 'info');
        }, 2000);
        
      } catch (error) {
        console.error('❌ Assign failed:', error);
        this.showMessage(error.response?.data?.message || 'Failed to assign database', 'error');
      } finally {
        this.loading = false;
      }
    },

    async openUserManager() {
      // نفتح الـ user manager في tab جديدة أو نعمل navigate
      this.$router.push('/control-panel');
      this.showMessage('Opening User Management Panel...', 'info');
    },

    async refreshDatabases() {
      await this.loadDatabases();
    },

    showMessage(text, type) {
      this.message = text;
      this.messageType = type;
      
      // نخفي الرسالة بعد 5 ثواني
      setTimeout(() => {
        this.message = '';
        this.messageType = '';
      }, 5000);
    },

    getDBName(dbKey) {
  const dbMap = {
    'db1': 'Exxon Mobil Mostorod',
    'db2': 'Exxon Mobil Test',
    'db3': 'Exxon Mobil Alexandria'
    // الداتابيز الجديدة هتضاف هنا أوتوماتيك
  };
  
  // لو الداتابيز موجودة في الـ array، نستخدم الـ label منها
  const db = this.databases.find(d => d.name === dbKey);
  if (db) {
    // نستخرج اسم الداتابيز من الـ label
    return db.label.split(' (')[0] || dbKey;
  }
  
  return dbMap[dbKey] || dbKey;
},

    getDatabaseKeyFromName(dbName) {
      const dbMap = {
        'Mostorod25': 'db1',
        'aytest': 'db2'
      };
      return dbMap[dbName] || null;
    },

getDBDescription(dbKey) {
  // نجيب الداتابيز من الـ array
  const db = this.databases.find(d => d.name === dbKey);
  
  // لو الداتابيز موجودة وعندها description في الـ API، نرجعه
  if (db && db.description) {
    return db.description;
  }
  
  // لو مفيش description في الـ API، نستخدم الـ fallback
  const descMap = {
    'db1': 'Production Site',
    'db2': 'Test Site',
    'db3': 'Alexandria Site'
  };
  
  return descMap[dbKey] || 'Database';
},

getCurrentDBDescription() {
  // نجيب الداتابيز الحالية من الـ array
  const db = this.databases.find(d => d.name === this.currentDatabase);
  
  // لو الداتابيز موجودة وعندها description في الـ API، نرجعه
  if (db && db.description) {
    return db.description;
  }
  
  // لو مفيش description في الـ API، نستخدم الـ fallback
  const descMap = {
    'db1': 'Exxon Mobil Mostorod',
    'db2': 'Exxon Mobil Test', 
    'db3': 'Exxon Mobil Alex'
  };
  
  return descMap[this.currentDatabase] || 'Switching';
},


    getUserRole() {
      if (!this.currentUser?.roles) return 'User';
      
      if (this.currentUser.roles.includes('super_admin')) return 'Super Admin';
      if (this.currentUser.roles.includes('admin')) return 'Admin';
      if (this.currentUser.roles.includes('manager')) return 'Manager';
      return 'User';
    },

    getMessageIconClass(type) {
      const icons = {
        'success': 'fas fa-check-circle',
        'error': 'fas fa-exclamation-circle',
        'info': 'fas fa-info-circle'
      };
      return icons[type] || 'fas fa-bell';
    }
  }
};
</script>

<style scoped>
.database-switcher-enhanced {
  display: flex;
  align-items: center;
}

/* Dropdown Toggle - نفس ستايل الـ user menu */
.dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  color: #555;
  font-weight: 500;
  text-decoration: none;
  border: none;
  background: none;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.dropdown-toggle:hover {
  color: #007bff;
  background-color: rgba(0, 123, 255, 0.08);
  text-decoration: none;
}

.dropdown-toggle:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.switch-icon {
  font-size: 0.9rem;
  margin-right: 0.5rem;
}

/* Dropdown Menu - نفس ستايل الـ dropdowns التانية */
.dropdown-menu {
  min-width: 280px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 8px 0;
}

.dropdown-header {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  padding: 4px 16px;
}

.db-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  transition: background-color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.db-option:hover {
  background-color: #e9ecef;
  color: #007bff;
  text-decoration: none;
}

.db-option-content {
  flex: 1;
}

.db-label {
  display: block;
  font-weight: 500;
  font-size: 0.85rem;
  color: #333;
}

.db-desc {
  font-size: 0.75rem;
  display: block;
  margin-top: 2px;
}

.active-indicator {
  font-size: 0.8rem;
  margin-left: 8px;
}

.refresh-icon {
  margin-right: 6px;
}

/* User Management Section */
.dropdown-item-text {
  font-size: 0.8rem;
}

.badge {
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
}

/* Alert Messages */
.alert-message {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 1050;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  max-width: 300px;
  animation: slideIn 0.3s ease;
}

.alert-message.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-message.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert-message.info {
  background: #cce7ff;
  color: #004085;
  border: 1px solid #b3d7ff;
}

.message-icon {
  font-size: 0.9rem;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .database-switcher-enhanced {
    width: 100%;
  }
  
  .dropdown-toggle {
    width: 100%;
    justify-content: center;
  }
  
  .alert-message {
    right: 10px;
    left: 10px;
    max-width: none;
  }
}

/* تأكد إن الـ styles بتاعة الـ enhanced-nav-link شغالة */
.enhanced-nav-link {
  position: relative;
  transition: color 0.3s ease, background-color 0.3s ease;
  overflow: hidden;
  text-decoration: none;
  display: block;
}

.enhanced-nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #007bff;
  transform: scaleX(0);
  transform-origin: bottom right;
  transition: transform 0.3s ease-out;
}

.enhanced-nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.enhanced-dropdown-menu {
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  padding: 8px 0;
}

.enhanced-dropdown-item {
  color: #333;
  padding: 10px 20px;
  transition: background-color 0.2s ease, color 0.2s ease;
  text-decoration: none;
  display: block;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.enhanced-dropdown-item:hover {
  background-color: #e9ecef;
  color: #007bff;
  text-decoration: none;
}
</style>